import { isEqual } from "lodash";

export function compare(
	value1: unknown,
	value2: unknown,
	deep = false,
): boolean {
	return deep ? isEqual(value1, value2) : value1 === value2;
}
